import { HTMLToCustomTextConverter } from '@lib/common'; // Get singleton instance and configure it

var converter = HTMLToCustomTextConverter.getInstance().withTransformTag('img', ' [Image] ').withTransformTag('a', ' [Link] ').withTransformTag('math-inline', ' [Math Formula] ').withTransformTag('table', ' [Table] ').withTransformTag('fib-blank', ' [Blank] ');
export var formatContent = function formatContent(content) {
  if (!content) return '';
  return converter.convert(content);
};